/**
 * Генерирует детерминированный цвет на основе префикса очереди
 * @param prefix - префикс очереди
 * @returns HSL цвет в формате "hsl(hue, saturation%, lightness%)"
 */
export function generateColorFromPrefix(prefix: string): string {
  let hash = 0;

  for (let i = 0; i < prefix.length; i++) {
    hash = prefix.charCodeAt(i) + ((hash << 5) - hash);
  }

  const STEP_HUE = 137;

  let rawHue = (hash * STEP_HUE) % 360;

  if (rawHue < 0) rawHue += 360;

  if (rawHue >= 40 && rawHue <= 65) {
    rawHue = (rawHue + 25) % 360;
  }

  const satSeed = (hash >> 5) & 31;
  const lightSeed = (hash >> 10) & 31;

  const saturation = 50 + (satSeed / 31) * 40;

  const lightnessVariants = [30, 45, 55, 65];
  const lightness = lightnessVariants[lightSeed % lightnessVariants.length];

  return `hsl(${Math.round(rawHue)}, ${Math.round(saturation)}%, ${lightness}%)`;
}
